import { Colors, Icon, Typography } from '@zapier/design-system';
import { css } from '@emotion/react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
const Styles = {
    root: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        margin: '5px 0px',
        borderRadius: '12px',
        padding: '20px 15px',
        backgroundColor: Colors.blue100,
        '&:focus, &:hover': {
            backgroundColor: Colors.cream,
            '& .offsite-icon svg': {
                color: Colors.brand,
            },
        },
        '&:focus': {
            outline: `2px solid ${Colors.brand}`,
        },
    }),
    header: css({
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    }),
    heading: css(Object.assign(Object.assign({}, Typography.paragraph3Medium), { color: Colors.neutral700 })),
    link: css({
        marginLeft: 'auto',
        color: Colors.neutral800,
    }),
    description: css(Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.neutral700 })),
};
export const Callout = ({ description, heading, href, icon, target, }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (isolateComponent("a", { css: Styles.root, href: getFullyQualifiedURL(href), "aria-label": `Navigate to ${heading}`, target: target, onClick: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                option_selected: `UniversalSidebar Callout ${href}`,
            });
        } },
        isolateComponent("div", null,
            isolateComponent("div", { css: Styles.header },
                icon && isolateComponent(Icon, { ariaHidden: true, name: icon }),
                isolateComponent("span", { css: Styles.heading }, heading),
                isolateComponent("div", { css: Styles.link, className: "offsite-icon" },
                    isolateComponent(Icon, { ariaHidden: true, name: "arrowOffsite", size: 24 })))),
        isolateComponent("span", { css: Styles.description }, description)));
};
//# sourceMappingURL=Callout.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
